import { useEffect, useState } from "react";
import { getTips } from "../services/tipService";

const useTips = () => {

    const [tips, setTips] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {

        const fetchTips = async () => {

            try {

                const data = await getTips();

                setTips(data);

            } catch (err) {

                setError(err);

            } finally {

                setLoading(false);

            }

        };

        fetchTips();

    }, []);

    return {
        tips,
        loading,
        error,
    };

};

export default useTips;